import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset, submit } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import ContentIcon, { HEADING_WEBVIEW } from "ContentIcon";
import { fetchWebview, insertWebview } from "ActionsWebview";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { screenHeightLeftFromTop } from "Constants";
// import Templates from 'Templates';
import InfoTutorial from "InfoTutorial";
import Loader from "Loader";
import LocaleStrings from "Languages";

class WebView extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      executed: false,
      loading: true,
      desc: LocaleStrings.preparingWebview,
    };

    this.formRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.contentAvailable)
      this.props.fetchWebview(this.props.session, (callback) => {
        this.setState({ loading: false });
      });
    else {
      this.props.history.push("/dashboard/content");
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contentAvailable !== this.props.contentAvailable) {
      if (nextProps.contentAvailable && !this.state.executed) {
        this.setState({ executed: true });
        this.props.fetchWebview(this.props.session);
      } else {
        this.props.history.push("/dashboard/content");
      }
    }
  };

  onFormSubmit(values) {
    // debugger;
    var data = { ...values };

    var webview = this.props.initialValues;
    this.setState({ loading: true });
    this.props.insertWebview(this.props.session, data, webview, (result) => {
      if (result.error === 1) {
        this.props.showError("Something is wrong");
      } else {
        this.props.showSuccess("Webview updated successfully");
        this.props.checkContentDashboardStatus(this.props.session);
      }
      this.setState({ loading: false });
    });
  }

  websiteCreationCallback = (website_url) => {
    //debugger;
    this.props.change("websiteurl", website_url);
    //this.props.startSubmit('LoginForm');
    //this.setState({loading:true});
    setTimeout(() => {
      this.props.dispatch(submit("WebViewForm"));
    }, 200);
  };

  submitFinished = () => {
    this.props.stopSubmit("LoginForm");
  };

  render() {
    var {
      handleSubmit,
      dirty,
      valid,
      pristine,
      reset,
      submitting,
      editorState,
      onEditorChange,
      invalid,
      submit,
      deviceSize,
    } = this.props;
    var disabled = pristine || invalid || submitting;

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_WEBVIEW} />
          </div>
          <div className="pull-right h-100 vertical-align-center  content-end">
            <InfoTutorial video="webview.mp4" />
          </div>
        </div>
        <div className="clearfix"></div>

        {/*
          <div>
            <h5 className="webview-padding">Choose Template from the List to create a Website on fly.</h5>
            <Templates embedded={true} websiteCreationCallback={this.websiteCreationCallback}/>
          </div>
          <h2 className="text-center">OR</h2>
          <div className="clearfix">&nbsp;</div>
          <div className="h-divider">&nbsp;</div>
      */}

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(submit)} ref={this.formRef}>
              <div suppressContentEditableWarning={true}>
                <Field
                  name="websiteurl"
                  label={LocaleStrings.webview_label_websiteurl}
                  type="text"
                  placeholder={LocaleStrings.webview_placeholder_websiteurl}
                  component={this.renderFieldText}
                  mandatory="false"
                  labelposition={LABEL_POSITION_TOP}
                />
                <h5 className="webview-padding webview-font-weight webview-font-size">
                  {LocaleStrings.webview_html}
                </h5>
                <Field
                  name="htmlcontent"
                  placeholder={LocaleStrings.webview_placeholder_html}
                  mandatory="false"
                  type="minimal"
                  // mandatory="false"
                  component={this.renderRichTextareaWithLabelTinymce}
                  labelposition={LABEL_POSITION_TOP}
                  height={400}
                />
                <div></div>
                <Button
                  type="submit"
                  className="pull-right btn btn-custom-blue"
                  loading={submitting}
                  disabled={disabled}
                >
                  {LocaleStrings.webview_save}
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var availableFeatures = state.availableFeatures.filter(
    (feature) => feature.available
  );
  var selectedFeature = availableFeatures.filter(
    (feature) => feature.bsClass === state.selectedContentFeature.bsClass
  );
  var contentAvailable = selectedFeature.length > 0;
  return {
    session: state.session,
    initialValues: state.webview[0],
    contentAvailable,
    deviceSize: state.deviceSize,
  };
}

function isValidDomain(v) {
  if (!v) return false;
  var re =
    /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;
  return re.test(v);
}

function validate(values) {
  var errors = {};

  var re =
    /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;

  if (values.websiteurl) {
    var validUrl = require("valid-url");

    if (!validUrl.isUri(values.websiteurl)) {
      if (!re.test(values.websiteurl)) {
        errors = {
          websiteurl: "Please provide valid URL",
        };
      }
    }
  }

  return errors;
}

function onFormSubmit(values, dispatch, props) {
  // debugger;
  props.startSubmit("WebViewForm");
  props.submitWebviewDataHandler(values, props.initialValues, props);
}

export default connect(mapStateToProps, {
  fetchWebview,
  insertWebview,
  checkContentDashboardStatus,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "WebViewForm",
    enableReinitialize: true,
    onSubmit: onFormSubmit,
  })(WebView)
);
